import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { toast } from 'react-toastify';
import { labRequestReqs } from '../../../helpers/adipiBackendUrl';
import { getTable, postApiCall } from "../../../services/mainServices";
import {
  ADD_NEW_LABREQUESTREQ,
  DELETE_LABREQUESTREQ,
  GET_LABREQUESTREQS,
  UPDATE_LABREQUESTREQ
} from "./actionTypes";
import {
  addLabRequestReqFail,
  addLabRequestReqSuccess,
  deleteLabRequestReqFail,
  deleteLabRequestReqSuccess,
  getLabRequestReqsFail,
  getLabRequestReqsSuccess,
  setState,
  updateLabRequestReqFail,
  updateLabRequestReqSuccess,
} from "./actions";
//Include Both Helper File with needed methods

function* fetchLabRequestReqs( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable,labRequestReqs, params.toString());
    yield put(setState(false))
    yield put(getLabRequestReqsSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getLabRequestReqsFail(error));
  }
}

function* updateLabRequestReq ({payload: labRequestReqObj }) {
  try {
    const response = yield call(getTable,`${labRequestReqs}/${labRequestReqObj.id}`);
    yield put(updateLabRequestReqSuccess(response));
    toast.success('Registro actualizado correctamente')
  } catch (error) {
    yield put(updateLabRequestReqFail(error));
    toast.error('Error al actualizar el registro')
  }
}

function* deleteLabRequestReq ({payload: labRequestReqObj}) {
  try {
    yield put(deleteLabRequestReqSuccess(labRequestReqObj.id));
    toast.success('Registro borrado correctamente')
  } catch (error) {
    yield put(deleteLabRequestReqFail(error));
    toast.error('Error al borrar el registro')
  }
}

function* postingLabRequestReq ({ payload: labRequestReqObj}) {
  try {
    const response = yield call(postApiCall, labRequestReqs ,labRequestReqObj);
    const response2 = yield call(getTable,`${labRequestReqs}/${response.id}`);
    yield put(addLabRequestReqSuccess(response2));
    toast.success('Registro agregado correctamente')
  } catch (error) {
    yield put(addLabRequestReqFail(error));
    toast.error('Error al agregar el registro')
  }
}

function* labRequestReqsSaga() {
  yield takeEvery(GET_LABREQUESTREQS, fetchLabRequestReqs);
  yield takeEvery(ADD_NEW_LABREQUESTREQ, postingLabRequestReq);
  yield takeEvery(UPDATE_LABREQUESTREQ, updateLabRequestReq);
  yield takeEvery(DELETE_LABREQUESTREQ, deleteLabRequestReq);
}

export default labRequestReqsSaga;
